import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';

import {
    articleExternalHref,
    type ArticleCardProps,
} from '@/lib/article-card';

/**
 * Article teaser link: local `/article/$id`, or the article's redirect URL
 * when "כתובת הפניה" is set.
 */
export function ArticleCardLink({
    article,
    className,
    children,
}: {
    article: Pick<ArticleCardProps, 'slug' | 'redirect'>;
    className?: string;
    children: ReactNode;
}) {
    const external = articleExternalHref(article.redirect);
    if (external) {
        const isAbsolute = /^https?:\/\//i.test(external);
        return (
            <a
                href={external}
                className={className}
                {...(isAbsolute
                    ? { target: '_blank', rel: 'noopener noreferrer' }
                    : {})}
            >
                {children}
            </a>
        );
    }

    return (
        <Link
            to="/article/$id"
            params={{ id: article.slug }}
            className={className}
        >
            {children}
        </Link>
    );
}
